import { ChartConfig } from './chart.model';

// Default Highcharts config used across time-series charts in the app.
export const TIME_SERIES_CHART_CONFIG: ChartConfig = {
  type: 'line',
  xAxis: {
    type: 'datetime',
    dateTimeFormat: {
      day: '%d',
      month: '%b %Y'
    }
  }
};

